import { auth, db } from './firebase/firebase';
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import { doc, setDoc, getDocs, collection,query } from "firebase/firestore";
import { useState, useEffect } from 'react';
import queryString from 'query-string';
import '../../../src/styles/login.css';
import { useDispatch } from 'react-redux';
import { setDataKey } from '../../actions/actionMethod';
import { encrypt } from '../../encryption';


const Login = () => {
  localStorage.removeItem('ref');
  const referral= queryString.parse(window.location.search);
  console.log(referral.ref);
  const users=[];
  const navigate = useNavigate();
  const signIn = async () => {
    const q = query(collection(db, "user"));

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      const user={info:doc.data()}
      users.push(user)
    });
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider).then((re) => {
      localStorage.setItem('session',JSON.stringify(re._tokenResponse));
      localStorage.setItem('user-key',(encrypt(re._tokenResponse.email)));
      if(users.map((user)=>(user.info.email)).includes(re._tokenResponse.email)){
        navigate('/dashboard/');
      }else{
        navigate('/dashboard/coupon');
        localStorage.setItem( "ref", referral.ref != undefined ? referral.ref : null);
      }
      
    }).catch((err) => {
      console.log(err);
    })
  }
  return (
    <div className="dashboard login-container">
      <div className="login-card">
        <p className="logo-2">Viralclicks<span>-mine</span></p> 
        <p className='text'>Sign in to join multitudes in tapping from what viralclicks-mine has to offer 😊</p>
        <div className="btn-flex">
          <i className="ri-google-fill"></i>
          <button onClick={signIn}> Continue with Gmail</button>
        </div>
        <span className='text faded'>or you can sign-in with your social handles</span>
        <div className="btn-flex">
          <i className="ri-twitter-fill"></i>
          <button>twitter</button>
        </div>
        <div className="btn-flex">
          <i className="ri-facebook-fill"></i>
          <button> facebook</button>
        </div>
      </div>
    </div>
      
  );
}

export default Login;
